import styled from 'styled-components'
import { Fonts, Icon } from 'components/base-ui'
import media from 'styles/media'

const CouponListContainer = styled.div`
  width: 100%;
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  row-gap: 16px;
`

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const Title = styled(Fonts.BaseTitleBold)`
  font-size: 14px;
  display: flex;
  align-items: center;
  column-gap: 4px;

  @media (${media.screenSmMiniMax}) {
    font-size: 12px;
  }

  @media (${media.screenXsMax}) {
    font-size: 10px;
  }
`

const RefreshText = styled(Fonts.SmallTitleRegular)`
  color: ${({ theme }) => theme.colors.primary};
  white-space: nowrap;
  text-decoration: underline;
`

const InfoBox = styled.div`
  display: flex;
  align-items: center;
  column-gap: 4px;
  padding: 12px 16px;
  background-color: #f2f9ff;
  color: ${({ theme }) => theme.colors.infoDark};
  border-radius: 4px;
  font-size: 14px;
`

const InfoText = styled(Fonts.SmallTitleRegular)`
  color: ${({ theme }) => theme.colors.infoDark};
`

const CouponListSection = styled.div`
  display: flex;
  flex-direction: column;
`

const CouponItemWrapper = styled.div<{ borderTop: boolean }>`
  padding: 8px 0;
  border-top: ${({ borderTop }) => (borderTop ? '1px solid #eeeeee' : 'none')};
`

const EmptyStateWarpper = styled(CouponListSection)`
  justify-content: center;
  align-items: center;
  row-gap: 20px;
  padding-top: 20px;
  text-align: center;
`

const TitleIcon = styled(Icon)`
  @media (${media.screenSmMiniMax}) {
    font-size: 14px;
  }
  @media (${media.screenXsMax}) {
    font-size: 12px;
  }
`

export {
  CouponListContainer,
  Header,
  Title,
  RefreshText,
  InfoBox,
  InfoText,
  CouponListSection,
  CouponItemWrapper,
  EmptyStateWarpper,
  TitleIcon,
}
